import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'

import ModalContainer from '../../../common/modal/ModalContainer'
import { ReactComponent as CloseIcon } from '../../../../assets/icons/close.svg'

const ETDListModal = React.memo(({ onCloseModal, designEdtList }) => {
    const timelineStore = useSelector((store) => store.timeline)
    const [memberList, setMemberList] = useState([])
    const [showMembers, setShowMembers] = useState(false)
    const wrapperRef = useRef()

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            setShowMembers(false)
        }
    }

    useEffect(() => {
        if (timelineStore.orderInfo?.orderMemberList) {
            setMemberList(timelineStore.orderInfo.orderMemberList)
        }
    }, [timelineStore])
    function getStatusText(design) {
        if (design?.actualDeliveryDate) {
            return <p className='regular-14 green'>Delivered</p>
        } else if (design?.deliveryDate) {
            const now = moment() // Current date and time
            const deliveryDate = moment(design.deliveryDate, 'YYYY-MM-DD') // Parse deliveryDate

            if (deliveryDate.isAfter(now)) {
                return (
                    <p className='regular-14'>
                        Due in {deliveryDate.diff(now, 'days')} days
                    </p>
                )
            } else {
                return (
                    <p className='regular-14 red'>
                        {Math.abs(deliveryDate.diff(now, 'days'))} days Overdue
                    </p>
                )
            }
        } else {
            return <p className='regular-14'>No delivery date available</p>
        }
    }
    return (
        <div>
            <ModalContainer
                className='estimated-delivery-modal'
                onCloseModal={onCloseModal}
            >
                <div className='common-popup'>
                    <div className='common-popup-header d-flex justify-content-between'>
                        <div className='popup-tilte'>
                            <h3 className='semibold-16 mb-0'>
                                Estimated Delivery Date
                            </h3>
                        </div>
                        <div
                            className='close-btn cursor-pointer'
                            onClick={onCloseModal}
                        >
                            <CloseIcon />
                        </div>
                    </div>

                    <div className='common-popup-body scroll-y-label p-4 !pt-0'>
                        <div className='estimated-delivery-table pb-4'>
                            <table className='table small-padding'>
                                <thead>
                                    <tr>
                                        <th>PO NO</th>
                                        <th>ETD</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {designEdtList?.map((rfq) => (
                                        <tr key={rfq.rfqId}>
                                            <td>{rfq?.poNumber}</td>
                                            <td>
                                                {moment(
                                                    rfq?.deliveryDate
                                                ).format('Do MMM, YY')}
                                            </td>
                                            <td>{getStatusText(rfq)}</td>
                                        </tr>
                                    ))}

                                    {/* <tr>
                                            <td>125/ASK/21-24/125</td>
                                            <td>19th Sep, 24</td>
                                            <td>Delivered</td>
                                        </tr>
                                        <tr>
                                            <td>125/ASK/21-24/125</td>
                                            <td>19th Sep, 24</td>
                                            <td>Delivered</td> 
                                        </tr>*/}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ModalContainer>
        </div>
    )
})

export default ETDListModal
